import React from 'react';
import clsx from 'clsx';
import { NotificationItem, MessageType } from 'types/Notification';
import { useNavigate } from 'react-router-dom';
import useNotifications from 'views/Notifications/hooks/useNotifications';
import { NIcon } from '@innersource-nn/novoui-react';

const NotificationCard = ({
    message,
    is_read,
    type,
    created,
    target_uri,
    notificationUri,
}: NotificationItem) => {
    const navigate = useNavigate();
    const { markAsRead } = useNotifications();

    const subtitle =
        'To see more details regarding your request, click on this notification';

    const getBgColor = () => {
        switch (type) {
            case MessageType.SHARE_OBJECT_REJECTED:
                return 'bg-red-500';
            case MessageType.SHARE_OBJECT_SUBMITTED:
                return 'bg-forest-green-600';
            case MessageType.SHARE_ITEM_REQUEST:
                return 'bg-true-blue';
            case MessageType.SHARE_OBJECT_APPROVED:
                return 'bg-forest-green-600';
            default:
                return 'bg-faded-blue-300';
        }
    };

    const getIcon = () => {
        switch (type) {
            case MessageType.SHARE_OBJECT_REJECTED:
                return (
                    <NIcon iconName="delete" size={26} className="fill-white" />
                );

            case MessageType.SHARE_OBJECT_SUBMITTED:
                return (
                    <NIcon iconName="send" size={26} className="fill-white" />
                );

            case MessageType.SHARE_ITEM_REQUEST:
                return (
                    <NIcon
                        iconName="lockOpen"
                        size={26}
                        className="fill-white"
                    />
                );
            case MessageType.SHARE_OBJECT_APPROVED:
                return (
                    <NIcon
                        iconName="success"
                        size={26}
                        className="fill-white"
                    />
                );
            default:
                return (
                    <NIcon
                        iconName="notifications"
                        size={26}
                        className="fill-white"
                    />
                );
        }
    };

    const handleClick = () => {
        const parts = target_uri.split('|');
        // Extract the shareUri and datasetUri
        const shareUri = parts[0];
        const datasetUri = parts[1];
        markAsRead(notificationUri);
        if (type === MessageType.SHARE_OBJECT_APPROVED) {
            navigate(`/dataset/${datasetUri}`);
        } else {
            navigate(`/share/${shareUri}`);
        }
    };

    // THIS WILL BE DELETED WHEN THE BACKEND RELEASES THE EDIT OF THE MESSAGE
    const replaceEmailWithInitials = () => {
        // Remove "@novonordisk.com"
        let inputString = message.replace(/@novonordisk\.com/g, '');
        // Remove "User" from the text
        inputString = inputString.replace(/\bUser\b/g, '');

        // Match any four characters followed by "@novonordisk.com"
        const regex = /(\b\w{4}\b)@novonordisk\.com/g;

        // Function to convert matched string to uppercase
        const toUpperCase = (match: string, p1: string) => p1.toUpperCase();

        // Replace the matched pattern with uppercase equivalent
        inputString = inputString.replace(regex, toUpperCase);

        return inputString;
    };

    return (
        <div
            onClick={handleClick}
            className={clsx(
                is_read ? 'bg-white' : 'bg-sea-blue-100',
                'h-[92px] items-center px-24 justify-between text-sm shadow-md flex text-true-blue p-12 rounded-8 cursor-pointer focus:ring focus:ring-light-blue-400 hover:shadow-2xl group relative hover:overflow-auto',
            )}
        >
            <div className="flex justify-start items-center gap-16">
                <div
                    className={clsx(
                        'round-div-icon-middle',
                        getBgColor(),
                        'w-14 h-14',
                    )}
                >
                    {getIcon()}
                </div>
                <div className="blocktext-md text-true-blue">
                    <p className="text-xs">{created}</p>
                    <b>{replaceEmailWithInitials()}</b>
                    <p>{subtitle}</p>
                </div>
            </div>

            <div className="round-div-icon-middle bg-sea-blue-600 w-10 h-10">
                <NIcon iconName="arrowRight" size={16} className="fill-white" />
            </div>
        </div>
    );
};

export default NotificationCard;
